import React from 'react';

const Criminal = () => {
    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>Criminal</h1>
            </div>
        </div>
    );
};

export default Criminal;